import { Component } from '@angular/core';
import { NgClass } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { SystemAdminHeaderComponent } from '../system-admin-header/system-admin-header.component';
import { FooterComponent } from '../../../common/components/footer/footer.component';

@Component({
  selector: 'app-system-admin-layout',
  standalone: true,
  templateUrl: './system-admin-layout.component.html',
  styleUrls: ['./system-admin-layout.component.scss'],
  imports: [
    NgClass,
    RouterOutlet,
    SystemAdminHeaderComponent,
    FooterComponent,
  ],
})
export class SystemAdminLayoutComponent {}
